var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imageView"},[_c('el-image',{style:(`width:100%;height:${_vm.realHeight};`),attrs:{"src":`${_vm.realSrc}`,"fit":"cover","fits":"cover","preview-src-list":_vm.realSrcList}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }